import {Helpers} from '@app/shared';
import {BaseModelSearchParams, BaseModelSearchParamsInterface} from '@app/abstracts';

/** Used to export and import search params */
export interface UserSearchParamsInterface extends BaseModelSearchParamsInterface {
  _sort?: '_id' | 'created_at'| 'name'| 'email'
  _id?: string[];
  _text?: string;
  name?: string;
  role?: string;
  email?: string;
  email_confirmed?: 'true' | 'false' | boolean;
}

/** Manage user search params */
export class UserSearchParams extends BaseModelSearchParams< UserSearchParamsInterface> {

  /** @inheritDoc */
  fromObject(input: Partial< UserSearchParamsInterface>): void {

    // Clone object with allowed keys only
    const props = {} as UserSearchParamsInterface;
    this.allowedKeys().map((key: string) => {
      if (typeof input[key] !== 'undefined') {
        props[key] = input[key];
      }
    });

    // Keep default values
    if (typeof props._page === 'undefined') { props._page = this.defaultPage; }
    if (typeof props._limit === 'undefined') { props._limit = this.defaultLimit; }
    if (typeof props._sort === 'undefined') { props._sort = this.defaultSort; }
    if (typeof props._order === 'undefined') { props._order = this.defaultOrder; }
    // Convert potentially multiple primary keys
    if (typeof props._id === 'string') {
      props._id = (< string>props._id).split(',').filter((s) => s.length);
    }

    // Convert boolean email confirmed
    if (typeof props.email_confirmed !== 'undefined') {
      props.email_confirmed = Helpers.convertToBoolean(props.email_confirmed);
    }

    // Assign values
    this.props = props;
    this.next();
  }
  /** @inheritDoc */
  toObject(): UserSearchParamsInterface {

    // Filter not allowed, undefined and null values
    const props = {} as UserSearchParamsInterface;
    this.allowedKeys().map(Helpers.prepareObjectForApi(this.props, props));

    // Convert boolean email confirmed
    if (typeof props.email_confirmed !== 'undefined') {
      props.email_confirmed = props.email_confirmed ? 'true' : 'false';
    }

    return props;
  }
  /** @inheritDoc */
  protected allowedKeys(): string[] {
    return super.allowedKeys().concat([
      '_id',
      '_text',
      'name',
      'role',
      'email',
      'email_confirmed',
    ]);
  }
}
